// src/components/noticias/NoticiaCard.js
import React from 'react';

function NoticiaCard({ noticia, onSelect }) {
  return (
    <button 
      onClick={() => onSelect(noticia)}
      className="w-full text-left"
    >
      <div className="group relative overflow-hidden rounded-xl bg-brand-dark/50">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={noticia.images[0]}
            alt={noticia.title}
            className="w-full h-full object-cover transition duration-300 group-hover:scale-110"
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
          <h3 className="text-xl font-morganite text-brand-white">
            {noticia.title}
          </h3>
        </div>
      </div>
    </button>
  );
}

export default NoticiaCard;